/** Clés de cache centralisées : évite les invalidations à côté de la plaque. */
export const queryKeys = {
  auth: {
    me: () => ['auth', 'me'] as const,
  },
  adminAuth: {
    me: () => ['admin', 'me'] as const,
  },
  admins: {
    all: () => ['admin', 'admins'] as const,
    list: () => ['admin', 'admins', 'list'] as const,
  },
  adminBilling: {
    all: () => ['admin', 'billing'] as const,
    transactions: (params: Record<string, unknown>) =>
      ['admin', 'billing', 'transactions', params] as const,
  },
  adminOverview: {
    all: () => ['admin', 'overview'] as const,
    byDays: (days: number) => ['admin', 'overview', days] as const,
  },
  adminUsers: {
    all: () => ['admin', 'users'] as const,
    list: (params: Record<string, unknown>) => ['admin', 'users', 'list', params] as const,
    detail: (id: string) => ['admin', 'users', 'detail', id] as const,
  },
  adminEmails: {
    queue: () => ['admin', 'emails', 'queue'] as const,
    all: () => ['admin', 'emails'] as const,
    activity: (params: Record<string, unknown>) => ['admin', 'emails', 'activity', params] as const,
    deliveries: (params: Record<string, unknown>) =>
      ['admin', 'emails', 'deliveries', params] as const,
  },
  adminExtension: {
    syncs: (params: Record<string, unknown>) => ['admin', 'extension', 'syncs', params] as const,
  },
  adminMessages: {
    list: (params: Record<string, unknown>) => ['admin', 'messages', params] as const,
    preview: (id: string) => ['admin', 'messages', 'preview', id] as const,
  },
  adminReviews: {
    list: (params: Record<string, unknown>) => ['admin', 'reviews', params] as const,
    forms: (params: Record<string, unknown>) => ['admin', 'reviews', 'forms', params] as const,
  },
  adminDoctolib: {
    all: () => ['admin', 'doctolib'] as const,
    synchronisations: (params: Record<string, unknown>) =>
      ['admin', 'doctolib', 'synchronisations', params] as const,
    specialites: (params: Record<string, unknown>) =>
      ['admin', 'doctolib', 'specialites', params] as const,
    motifs: (params: Record<string, unknown>) => ['admin', 'doctolib', 'motifs', params] as const,
  },
  users: {
    all: () => ['users'] as const,
    list: () => ['users', 'list'] as const,
  },
  doctolib: {
    all: () => ['doctolib'] as const,
    releve: () => ['doctolib', 'releve'] as const,
    appointmentsContext: () => ['doctolib', 'appointments-context'] as const,
  },
  cabinet: {
    all: () => ['cabinet'] as const,
    profile: () => ['cabinet', 'profile'] as const,
  },
  messages: {
    all: () => ['messages'] as const,
    list: () => ['messages', 'list'] as const,
  },
  deliveries: {
    all: () => ['deliveries'] as const,
    list: (filters: unknown) => ['deliveries', 'list', filters] as const,
    counts: () => ['deliveries', 'counts'] as const,
    detail: (id: string) => ['deliveries', 'detail', id] as const,
  },
  emailSettings: {
    all: () => ['email-settings'] as const,
    detail: () => ['email-settings', 'detail'] as const,
  },
  dashboard: {
    detail: (days: number) => ['dashboard', days] as const,
  },
  reviews: {
    all: () => ['reviews'] as const,
    list: () => ['reviews', 'list'] as const,
    config: () => ['reviews', 'config'] as const,
    form: (token: string) => ['reviews', 'form', token] as const,
  },
  billing: {
    invoices: () => ['billing', 'invoices'] as const,
    credit: () => ['billing', 'credit'] as const,
    cancelPreview: () => ['billing', 'annulation', 'apercu'] as const,
  },
} as const;
